import React from 'react';
import { motion } from 'framer-motion';
import { PlayCircle } from 'lucide-react';
export function CoverHero() {
  return <section className="relative min-h-screen bg-gradient-to-br from-slate-950 via-slate-900 to-slate-950 flex items-center justify-center overflow-hidden" data-id="element-33">
      {/* Subtle animated background elements */}
      <motion.div className="absolute inset-0 opacity-10" animate={{
      backgroundPosition: ['0% 0%', '100% 100%']
    }} transition={{
      duration: 20,
      repeat: Infinity,
      repeatType: 'reverse'
    }} style={{
      backgroundImage: 'radial-gradient(circle at 20% 50%, rgba(226, 35, 26, 0.3) 0%, transparent 50%), radial-gradient(circle at 80% 80%, rgba(226, 35, 26, 0.2) 0%, transparent 50%)',
      backgroundSize: '100% 100%'
    }} data-id="element-34" />

      <div className="relative z-10 max-w-5xl mx-auto px-6 text-center" data-id="element-35">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8
      }} className="mb-6" data-id="element-36">
          <PlayCircle className="w-16 h-16 mx-auto text-red-600 mb-8" strokeWidth={1.5} data-id="element-37" />
        </motion.div>

        <motion.h1 initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="font-editorial text-6xl md:text-7xl lg:text-8xl font-bold text-white mb-6 leading-tight" data-id="element-38">
          The Tralo Master-Class
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.4
      }} className="text-xl md:text-2xl text-slate-300 mb-12 max-w-3xl mx-auto leading-relaxed" data-id="element-39">
          A speaker-deck concept for Leo Pharma — 6 KOL videos, 4 experiential
          layers
        </motion.p>

        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 0.8,
        delay: 0.6
      }} className="flex items-center justify-center gap-8 text-sm text-slate-400" data-id="element-40">
          <span className="border-l-2 border-red-600 pl-4" data-id="element-41">
            Prepared for Leo Pharma
          </span>
          <span data-id="element-42">
            {new Date().toLocaleDateString('en-US', {
            month: 'long',
            year: 'numeric'
          })}
          </span>
        </motion.div>
      </div>

      {/* Scroll indicator */}
      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1,
      y: [0, 10, 0]
    }} transition={{
      opacity: {
        delay: 1
      },
      y: {
        duration: 2,
        repeat: Infinity
      }
    }} className="absolute bottom-12 left-1/2 -translate-x-1/2" data-id="element-43">
        <div className="w-6 h-10 border-2 border-slate-600 rounded-full flex items-start justify-center p-2" data-id="element-44">
          <div className="w-1 h-2 bg-slate-600 rounded-full" data-id="element-45" />
        </div>
      </motion.div>
    </section>;
}